"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Watermark_1 = require("./Watermark");
exports.Watermark = Watermark_1.default;
//# sourceMappingURL=index.js.map